import APFooter from "./APFooter";

export default APFooter;
